import React, { FunctionComponent, useState } from 'react';
import type { RecruitmentShowContentProps } from './types';
import { RecruitmentPageContent, CompanyProfileDetails } from '../../../types/recruitmentShow';
import { RecruitmentShowContentModal } from '../../molecules/recruitmentShowContentModal';
import { RecruitmentShowContentInfo } from '../../molecules/recruitmentShowContentInfo';
import { RecruitmentShowContentScoutMessage } from '../../molecules/recruitmentShowContentScoutMessage';
import { RecruitmentShowContentFollow } from '../../molecules/recruitmentShowContentFollow';
import { RecruitmentShowContentChild } from '../../molecules/recruitmentShowContentChild';
import { RecruitmentShowContentDetails } from '../../molecules/recruitmentShowContentDetails'
import { RecruitmentShowCompany } from '../../molecules/recruitmentShowCompany';
import { RecruitmentShowCompanyDetails } from '../../molecules/recruitmentShowCompanyDetails';
import { RecruitmentShowApplications } from '../../molecules/recruitmentShowApplications';
import { RecruitmentShowMagazines } from '../../molecules/recruitmentShowMagazines';
import { RecruitmentShowApplicationsSub } from '../../molecules/recruitmentShowApplicationsSub';

type Props = RecruitmentShowContentProps & {
  isPc: boolean;
  contentState: RecruitmentPageContent;
  companyState: CompanyProfileDetails;
};

export const Presentation: FunctionComponent<Props> = ({
  recruitmentId,
  companyId,
  messageBoxId,
  noimage,
  noIconImg,
  currentUser,
  isLoggedIn,
  isCompany,
  connectedFlag,
  isScouted,
  isStopped,
  isShow,
  isUser,
  user,
  occupationUrl,
  occupationName,
  industryUrl,
  dataCategory,
  dataValue,
  handleRegisterModalOpen,
  handleClickEntry,
  isPc,
  contentState,
  companyState,
  isPreview,
  handlePreviewClick,
  lineIcon,
  mags,
  isShowMag,
  isShowToggleInRecruitmentShowPage = false,
  isStoppedFv,
  hideTopEntryButton = false,
}) => {
  const [isCompanyInfoOpen, setIsCompanyInfoOpen] = useState(false);

  return (
    <div className={`recruitment__show__wrapper ${isStoppedFv && isStopped ? 'stopped' : ''}`}>
      {isPc && (
        <RecruitmentShowContentModal
          currentUser={currentUser}
          isLoggedIn={isLoggedIn}
          isCompany={isCompany}
          connectedFlag={connectedFlag}
          isScouted={isScouted}
          isStopped={isStopped}
          recruitmentId={recruitmentId}
          companyId={companyId}
          messageBoxId={messageBoxId}
          isShow={isShow}
          isPreview={isPreview}
          isShowMag={isShowMag}
          dataCategory={dataCategory}
          dataValue={dataValue}
          handleRegisterModalOpen={handleRegisterModalOpen}
          handleClickEntry={handleClickEntry}
          handlePreviewClick={handlePreviewClick}
        />
      )}
      <RecruitmentShowContentInfo
        connectedFlag={connectedFlag}
        handleRegisterModalOpen={handleRegisterModalOpen}
        recruitmentId={recruitmentId}
        isPc={isPc}
        isStopped={isStopped}
        dataCategory={dataCategory}
        dataValue={dataValue}
        messageBoxId={messageBoxId}
        isShowMag={isShowMag}
        handleClickEntry={handleClickEntry}
        isPreview={isPreview}
        handlePreviewClick={handlePreviewClick}
        isStoppedFv={isStoppedFv}
        hideTopEntryButton={hideTopEntryButton}
      />
      {!isStopped && currentUser && isScouted && (
        <RecruitmentShowContentScoutMessage
          recruitmentId={recruitmentId}
          companyId={companyId}
          dataCategory={dataCategory.recruitmentContent}
          dataValue={{
            scoutMessage: dataValue.scoutMessage,
            moreScoutMessage: dataValue.moreScoutMessage
          }}
        />
      )}
      {isStopped && (
        <RecruitmentShowContentFollow
          recruitmentId={recruitmentId}
          companyId={companyId}
          isStopped={isStopped}
          isUser={isUser}
          user={user}
          noimage={noimage}
          occupationName={occupationName}
          occupationUrl={occupationUrl}
          industryUrl={industryUrl}
          isCompany={isCompany}
          dataCategory={dataCategory}
          dataValue={dataValue}
          lineIcon={lineIcon}
          isPreview={isPreview}
          isStoppedFv={isStoppedFv}
        />
      )}
      <RecruitmentShowContentChild title='何をやるのか' content={contentState.what_todo_content_full} conditions={contentState.preferenceConditions.features} />
      <RecruitmentShowContentChild title='どんな人に来て欲しいか' content={contentState.why_need_content_full} conditions={contentState.preferenceConditions.candidateRequirements} />
      <div className="recruitment__show__content" id="recruitment-info-section">
        <h2 className="title">募集情報</h2>
        <RecruitmentShowContentDetails
          recruitmentId={recruitmentId}
          companyId={companyId}
          employmentTypes={contentState.employmentTypes}
          workingPeriod={contentState.workingPeriod}
          trialPeriod={contentState.trialPeriod}
          workingTime={contentState.workingTime}
          occupationNames={contentState.occupationNames}
          address={contentState.address}
          brands={contentState.brands}
          salary={contentState.salary}
          salaryDetail={contentState.salaryDetail}
          salaryDetailPresent={contentState.salaryDetailPresent}
          socialInsurances={contentState.socialInsurances}
          welfares={contentState.welfares}
          welfareOther={contentState.welfareOther}
          welfareOtherPresent={contentState.welfareOtherPresent}
          updatedAt={contentState.updatedAt}
          regularEmployee={contentState.regularEmployee}
          plannedHires={contentState.plannedHires}
          preferenceConditions={contentState.preferenceConditions}
          isStopped={isStopped}
          isPreview={isPreview}
        />
      </div>
      <RecruitmentShowCompany
        recruitmentId={recruitmentId}
        companyId={companyId}
        noimage={noimage}
        noIconImg={noIconImg}
        isStopped={isStopped}
        dataCategory={dataCategory}
        dataValue={dataValue.companyPeopleLink}
        isPreview={isPreview}
        isShowToggleInRecruitmentShowPage={isShowToggleInRecruitmentShowPage}
      />
      <div className="recruitment__show__content" id="company-info-section">
        {isShowToggleInRecruitmentShowPage ? (
          <>
            <button
              type="button"
              className="title recruitment__show__toggle gtm-toggle-view-count"
              onClick={() => setIsCompanyInfoOpen(!isCompanyInfoOpen)}
              aria-expanded={isCompanyInfoOpen}
              aria-controls="company-info-toggle-content"
              data-event-name="toggle on screen"
              data-event="click"
              data-category="recruitmentcontent"
              data-value="toggle_company_info"
            >
              会社情報
            </button>
            {isCompanyInfoOpen && (
              <div id="company-info-toggle-content">
                <RecruitmentShowCompanyDetails
                  name={companyState.name}
                  shihonkin={companyState.shihonkin}
                  setsuritsunengetsu={companyState.setsuritsunengetsu}
                  daihyoshaname={companyState.daihyoshaname}
                  jugyoinsu={companyState.jugyoinsu}
                  honshashozaichi={companyState.honshashozaichi}
                  industries={companyState.industries}
                />
              </div>
            )}
          </>
        ) : (
          <>
            <h2 className="title">会社情報</h2>
            <RecruitmentShowCompanyDetails
              name={companyState.name}
              shihonkin={companyState.shihonkin}
              setsuritsunengetsu={companyState.setsuritsunengetsu}
              daihyoshaname={companyState.daihyoshaname}
              jugyoinsu={companyState.jugyoinsu}
              honshashozaichi={companyState.honshashozaichi}
              industries={companyState.industries}
            />
          </>
        )}
      </div>
      <div className="recruitment__show__content">
        <div className="fw-slide"></div>
      </div>
      <RecruitmentShowApplications
        title='この企業のストーリー'
        noimage={noimage}
        companyId={companyId}
        recruitmentId={recruitmentId}
        isStopped={isStopped}
        dataCategory={dataCategory}
        dataValue={dataValue}
        isPreview={isPreview}
      />
      {isShowMag &&
        <RecruitmentShowMagazines
          title='この企業をもっと知る'
          noimage={noimage}
          isStopped={isStopped}
          dataCategory={dataCategory}
          dataValue={dataValue}
          isPreview={isPreview}
          mags={mags}
          companyId={companyId}
          recruitmentId={recruitmentId}
        />
      }
      {!isStopped && recruitmentId && (
        <RecruitmentShowApplicationsSub
          title='この企業の募集中求人'
          noimage={noimage}
          companyId={companyId}
          recruitmentId={recruitmentId}
          dataCategory={dataCategory.recruitmentContent}
          dataValue={dataValue}
          isPreview={isPreview}
        />
      )}
    </div>
  );
};
